import { render, staticRenderFns } from "./PublicProfileSettings.vue?vue&type=template&id=5fd62cb4"
import script from "./PublicProfileSettings.vue?vue&type=script&lang=js"
export * from "./PublicProfileSettings.vue?vue&type=script&lang=js"
import style0 from "./PublicProfileSettings.vue?vue&type=style&index=0&id=5fd62cb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports